import Sidebar from "@/components/Sidebar";
import { Outlet, useLocation, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { HeaderAuthBadge } from "@/components/auth/AuthWidgets";

const crumbMap = {
  "": "Dashboard",
  leads: "Leads",
  setup: "Product Setup",
};

export default function AppLayout() {
  const loc = useLocation();
  const parts = loc.pathname.split("/").filter(Boolean);
  const top = parts[0] || "";

  return (
    <div className="flex min-h-screen bg-white">
      <Sidebar />
      <main className="flex-1 flex flex-col min-w-0">
        <header
          className="sticky top-0 z-30 border-b border-slate-200 bg-white/80 backdrop-blur-xl"
          data-testid="topbar"
        >
          <div className="px-6 md:px-10 h-14 flex items-center justify-between">
            <div className="flex items-center gap-2 text-[13px] text-slate-600">
              <Link to="/" className="hover:text-slate-900">
                Profit10x
              </Link>
              <span className="text-slate-300">/</span>
              <span className="text-slate-900 font-medium">
                {crumbMap[top] ?? "Detail"}
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="chip">
                <span className="h-1.5 w-1.5 rounded-full bg-[#16A34A]" />
                Live
              </span>
              <span className="label-caps hidden lg:inline">
                claude-sonnet-4.5
              </span>
              <HeaderAuthBadge />
            </div>
          </div>
        </header>

        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
